// import React, { useState, useEffect } from 'react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { useSelector } from 'react-redux';

// const MyEditor = ({ selectedPrevData, handleEditorChange }) => {
//     const emailReplyEvent = useSelector((state) => state.redux.emailReply);
//     const [editorData, setEditorData] = useState(
//         // "<img src='https://app.applatus.com:9001/uploads/1726662862959-e6ae29dc-3ed0-4390-8320-71932bc7abf6-image.png' />"
//     );
//     // "<img src='http://192.168.29.43:3000/uploads/1726560315636-d13371cb-2eb5-4033-ad73-fb30b37811e6-Screenshot 2024-05-06 185002.png' />",
//     // "<img src='https://dev-reality-pulse.s3.ap-south-1.amazonaws.com/image_97431726560942.jpg' />"
//     // "<img src='https://images.unsplash.com/photo-1673859360509-1ef362f94f0c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTY3NjMzNjE2OA&ixlib=rb-4.0.3&q=80&w=1080' />"

//    useEffect(() => {
//     setEditorData(selectedPrevData?.templateData ?? '');
// }, [selectedPrevData]);



//     useEffect(() => {
//         if (emailReplyEvent) {
//             // setEditorData('');
//         }
//     }, [emailReplyEvent]);

//     const editorConfiguration = {
//         toolbar: {
//             items: [
//               'heading', '|',
//               'bold', 'italic', 'link',
//               'bulletedList', 'numberedList', '|',
//               'blockQuote', 'undo', 'redo', 'imageUpload',
//             ],
//             shouldNotGroupWhenFull: true, 
//           },
//         extraPlugins: [MyCustomUploadAdapterPlugin],
//     };

//     function MyCustomUploadAdapterPlugin(editor) {
//         editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
//             return new MyUploadAdapter(loader);
//         };
//     }

//     class MyUploadAdapter {
//         constructor(loader) {
//             this.loader = loader;
//         }

//         upload() {
//             return this.loader.file.then((file) => {
//                 const data = new FormData();
//                 data.append('image', file);
//                 return fetch(`${process.env.REACT_APP_BACKEND_URL}/template/singleImage`, {
//                     method: 'POST',
//                     body: data,
//                 })
//                     .then((response) => response.json())
//                     .then((result) => {
//                         return {
//                             default: `${process.env.REACT_APP_IMAGE_URL}/` + result?.image,
//                         };
//                     });
//             });

//         }

//         abort() {
//             // Handle abort action if needed
//         }
//     }
//     return (
//         <div>
//             <CKEditor
//                 config={editorConfiguration}
//                 editor={ClassicEditor}
//                 data={editorData}
//                 onChange={(content, editor) => {
//                     const cleanedString = editor.getData().replace(/<\/?figure[^>]*>/g, '');
//                     const dtT = cleanedString.replace(/(<img[^>]*)(?<!\/)>/g, '$1 />');
//                     handleEditorChange(editor.getData());
//                 }}
//                 onReady={(editor) => {
//                     editor.editing.view.change((writer) => {
//                         writer.setStyle('min-height', '400px', editor.editing.view.document.getRoot());
//                     });
//                 }}
//             />
//         </div>
//     );
// };

// export default MyEditor; 

import React, { useState, useEffect, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import CircularProgress from '@mui/material/CircularProgress';

const MyEditor = ({ selectedPrevData, handleEditorChange, allTemp = [], visibleReplies, selectedMail, isForward, textAreaValue, mode, idx, isReply }) => {
  const [editorData, setEditorData] = useState(textAreaValue || '');
  const [submitData, setSubmitData] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredList, setFilteredList] = useState(allTemp);
  const [dialogPosition, setDialogPosition] = useState({ top: 0, left: 0 });
  const [isReplyExpanded, setIsReplyExpanded] = useState(false);

  const editorRef = useRef(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    if (isReply) {
      setIsReplyExpanded(false);
    }
  }, [isReply]);

  let dataToShow = "";

  if (mode === 'replyAll') {
    dataToShow = selectedMail;
  } else if (mode === 'visible' && visibleReplies && idx !== undefined) {
    dataToShow = visibleReplies.find(v => v.id === idx) || "";
  } else if (mode === '-') {
    dataToShow = visibleReplies?.length > 0 ? visibleReplies[visibleReplies.length - 1] : "";
  } else {
    dataToShow = "";
  }

  const lastReplyBody = dataToShow;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  const forwardedHeader = `
    ---------- Forwarded message ---------<br/>
    From: ${lastReplyBody?.sender || selectedMail?.sentBy} <br/>
    Date: ${formatDate(lastReplyBody?.createdAt || selectedMail?.createdAt)}<br/>
    Subject: ${lastReplyBody?.subject || selectedMail?.subject}<br/>
    To: ${lastReplyBody?.receiver || selectedMail?.sentTo}<br/>
  `;

  const formattedBody = lastReplyBody?.body?.replace(/\n/g, '<br/>') || selectedMail?.body?.replace(/\n/g, '<br/>');
  const forwardedContent = isForward ? `${forwardedHeader}<br/><br/>${formattedBody}` : null;

  const collapsedContentHtml = `
    <div style="display: flex; flex-direction: column; height: 100%;">
        
      <div id="typing-area" style="flex-grow: 1;">
        <p><br></p>
      </div>
      
      <div contenteditable="false" style="flex-shrink: 0; padding: 8px 0px; user-select: none;">
        <span
          id="expand-btn"
          contenteditable="false"
          style="
            border-radius: 9999px;
            background-color: #e5e7eb; 
            padding: 4px 12px; 
            color: #374151;
            font-size: 14px;
            cursor: pointer;
          "
        > 
          ...
        </span>
      </div>

    </div>
  `;

  const replyHeader = `
    On ${formatDate(lastReplyBody?.createdAt || selectedMail?.createdAt)}, ${lastReplyBody?.sender || selectedMail?.sentBy} wrote:<br/>
  `;

  const expandedReplyContent = `<p><br></p>${replyHeader}<blockquote style="border-left:2px solid #ccc; margin:0; padding-left:8px; background:#f7f7f7;">
    ${(lastReplyBody?.body || selectedMail?.body)?.replace(/\n/g, '<br/>') || ''}
  </blockquote>`;

  const contentToSend = `${replyHeader}<br/>${(lastReplyBody?.body || selectedMail?.body)?.replace(/\n/g, '<br/>') || ''}`;

  useEffect(() => {
    if (isForward && forwardedContent) {
      setEditorData(forwardedContent);
      setSubmitData(forwardedContent);
    }
    if (selectedPrevData?.templateData && selectedPrevData?.templateData !== editorData) {
      const combined = (forwardedContent || '') + (selectedMail?.body?.replace(/\n/g, '<br/>') || '') + selectedPrevData?.templateData;
      setEditorData(combined);
      setSubmitData(combined);
    }

    if (isReply) {
      if (isReplyExpanded) {
        setEditorData(prev => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = prev;

          const typingArea = tempDiv.querySelector('#typing-area');
          const userInputHTML = typingArea ? typingArea.innerHTML : '';

          return `
        <div id="typing-area">${userInputHTML || '<p><br></p>'}</div>
        ${expandedReplyContent}
      `;
        });
      } else {
        setEditorData(collapsedContentHtml);
      }
      setSubmitData(contentToSend);
    }

  }, [isForward, isReply, isReplyExpanded, lastReplyBody, selectedPrevData]);


  useEffect(() => { setFilteredList(allTemp); }, [allTemp]);
  useEffect(() => { setFilteredList(allTemp?.filter(item => item.label.toLowerCase().includes(searchTerm.toLowerCase()))); }, [searchTerm, allTemp]);
  useEffect(() => { const handleClickOutside = (event) => { if (dialogRef.current && !dialogRef.current.contains(event.target) && editorRef.current && !editorRef.current.getContainer().contains(event.target)) { setShowDialog(false); } }; if (showDialog) { document.addEventListener('mousedown', handleClickOutside); } else { document.removeEventListener('mousedown', handleClickOutside); } return () => { document.removeEventListener('mousedown', handleClickOutside); }; }, [showDialog]);


  const getCaretPosition = () => {
    const editor = editorRef.current;
    if (!editor) return { top: 0, left: 0 };
    const rng = editor.selection.getRng();
    const rects = rng.getClientRects();
    if (rects.length > 0) {
      const rect = rects[0];
      return {
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      };
    }
    return { top: 0, left: 0 };
  };

  const handleKeyUp = (_event, editor) => {
    const content = _event.target.innerText || '';
    if (content.endsWith('**') && allTemp.length > 0) {
      const pos = getCaretPosition();
      setDialogPosition({ top: pos.top, left: pos.left });
      setSearchTerm('');
      setShowDialog(true);
    }

    if (_event.key === 'Escape') {
      setShowDialog(false);
    }
  };

  const handleSelect = (value) => {
    const editor = editorRef.current;
    const plainText = editor.getContent({ format: 'text' });
    if (plainText.endsWith('**')) {
      const newData = plainText.slice(0, -2) + value;
      editor.setContent(newData);
    } else {
      setEditorData(editorData + value);
      setSubmitData(editorData + value)
    }

    setShowDialog(false);
    setSearchTerm('');
  };

  return (
    <div style={{ position: 'relative' }}>
      <style>{`
         .tox-pop--left { display: none !important; }
         .tox-tbtn[aria-label="Align"],
         .tox-tbtn[aria-label="Adjust"],
         .tox-tbtn[aria-label="Filters"],
         .tox-tbtn[aria-label="Transform"],
         .tox-tbtn[aria-label="Alt text"],
         .tox-tbtn[aria-label="Caption"],
         .tox-tbtn[aria-label="Revert"],
         .tox-tbtn[aria-label="Upload from URL"] { display: none !important; }
         .custom-dialog {
           position: absolute;
           width: 280px;
           max-height: 250px;
           background: white;
           border: 1px solid #ccc;
           box-shadow: 0 2px 8px rgba(0,0,0,0.15);
           border-radius: 4px;
           z-index: 10000;
         }
         .custom-dialog input {
           box-sizing: border-box;
           width: 100%;
           padding: 8px 10px;
           border: none;
           border-bottom: 1px solid #ddd;
           outline: none;
           margin: 0;
         }
         .custom-dialog ul {
           list-style: none;
           margin: 0;
           padding: 0;
           max-height: 200px;
           overflow-y: auto;
         }
         .custom-dialog li {
           padding: 8px 10px;
           cursor: pointer;
         }
         .custom-dialog li:hover {
           background-color: #f0f0f0        }
       `}</style>
      {isLoading && (<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '200px', }}><CircularProgress /></div>)}

      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        licenseKey="gpl"
        value={editorData}
        onInit={(_evt, editor) => {
          setIsLoading(false);
          editorRef.current = editor;
          editor.on('click', (e) => {
            const target = e.target;
            if (target.id === 'expand-btn') {
              setIsReplyExpanded(true);
            }
          });
          if (editor) {
            editor.focus();
            const dom = editor.dom;
            const span = editor.dom.get('expand-btn');
            if (span) {
              const rng = editor.selection.getRng();
              rng.setStartBefore(span);
              rng.setEndBefore(span);
              editor.selection.setRng(rng);
            }
          }
        }}
        init={{
          menubar: false,
          statusbar: false,
          contextmenu: false,
          plugins: ['lists', 'link', 'autolink'],
          uploadcare_inline: false,
          uploadcare_shown_in_content: false,
          toolbar:
            'undo redo | bold italic underline strikethrough | align lineheight ',
          images_upload_handler: () => { },
          uploadcare_public_key: 'bb313bb09f2328194324',
          branding: false,
          skin_url: '/tinymce/skins/ui/oxide',
          content_css: '/tinymce/skins/content/default/content.min.css',
          content_style: `
    html, body {
      height: 100%;
      margin: 0;
    }
    body {
      padding: 8px 12px; /* Adds 8px space top/bottom, 12px space left/right */
      box-sizing: border-box; /* Ensures padding doesn't break height calculations */
    }
  `
        }}
        onEditorChange={(content) => {
          setEditorData(content);

          let finalContentToSend = content;

          if (isReply && !isReplyExpanded) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;

            const typingArea = tempDiv.querySelector('#typing-area');

            const userInputHTML = typingArea ? typingArea.innerHTML : '';

            finalContentToSend = userInputHTML + '<br>' + submitData;
          }

          if (handleEditorChange) {
            handleEditorChange(finalContentToSend);
          }
        }}
        onKeyUp={handleKeyUp}
      />
      {showDialog && (
        <div
          ref={dialogRef}
          className="custom-dialog"
          style={{ top: dialogPosition.top, left: dialogPosition.left }}
        >
          <input
            autoFocus
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <ul>
            {filteredList.length > 0 ? (
              filteredList.map((item) => (
                <li key={item.value} onClick={() => handleSelect(item.value)}>
                  {item.label}
                </li>
              ))
            ) : (
              <li style={{ color: '#999', cursor: 'default' }}>
                No results found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MyEditor;